var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-hint"},[_c('div',{staticClass:"sm-hint__content"},[_vm._t("hintContent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }